import { Button, Dialog } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { Accensione } from "../prismaTypes";
import { AccensioneUi } from "./AccensioneUi";
import { AccensioniProgTable } from "./AccensioniProgTable";
import { uiStore } from "../uiStore";

export function AccensioniProg() {
  const setTitle = uiStore((state) => state.setTitle);
  useEffect(() => setTitle("Timers"), [setTitle]);

  const [open, setOpen] = useState(false);
  const [acc, setAcc] = useState<Accensione | undefined>(undefined);
  const onNewClick = useCallback(() => {
    setAcc(undefined);
    setOpen(true);
  }, [setAcc, setOpen]);

  const onEdit = useCallback(
    (acc: Accensione) => {
      setAcc(acc);
      setOpen(true);
    },
    [setAcc, setOpen]
  );

  return (
    <>
      <Button onClick={onNewClick} variant="contained" color="success" sx={{ mb: 1 }}>
        Nuova Accensione
      </Button>
      <AccensioniProgTable onEdit={onEdit} />

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth={true}>
        <AccensioneUi accensione={acc} handleClose={() => setOpen(false)} />
      </Dialog>
    </>
  );
}
